export class UnauthorizedError extends Error {}

async function request(path, opts = {}) {
  const res = await fetch(path, {
    credentials: 'include',
    headers: opts.body ? { 'Content-Type': 'application/json' } : undefined,
    ...opts,
  });
  if (res.status === 401) {
    throw new UnauthorizedError('Not authenticated');
  }
  return res;
}

export async function apiGet(path) {
  const res = await request(path);
  return res.json();
}

export async function apiPost(path, body) {
  const res = await request(path, {
    method: 'POST',
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  return res.json();
}

// สำหรับ /api/auth/* — 401/429 ที่นี่คือ "รหัสผิด/ลองถี่เกิน" ไม่ใช่ "ยังไม่ได้ล็อกอิน"
// จึงต้องอ่าน body + status เอง (apiPost จะโยน UnauthorizedError ทิ้งข้อความจาก server ไป)
export async function authPost(path, body) {
  const res = await fetch(path, {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  });
  let data = {};
  try { data = await res.json(); } catch (e) { /* empty body */ }
  return { status: res.status, data };
}

// Bypasses request()'s forced `Content-Type: application/json` — the browser must set its own
// multipart boundary header for FormData, so this never touches headers at all.
export async function apiUpload(path, formData) {
  const res = await fetch(path, { method: 'POST', credentials: 'include', body: formData });
  if (res.status === 401) {
    throw new UnauthorizedError('Not authenticated');
  }
  return res.json();
}

export { request as apiRequest };
